// extracted by mini-css-extract-plugin
module.exports = {"root":"Header-module__root___tYKpB"};